var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvgBuilding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_6644_125816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 14H1.33325V12.6667H1.99992V2.66667C1.99992 2.48986 2.07016 2.32029 2.19518 2.19526C2.32021 2.07024 2.48977 2 2.66659 2H11.9999C12.1767 2 12.3463 2.07024 12.4713 2.19526C12.5963 2.32029 12.6666 2.48986 12.6666 2.66667V6H13.9999V12.6667H14.6666V14ZM11.3333 12.6667H12.6666V7.33333H8.66659V12.6667H9.99992V8.66667H11.3333V12.6667ZM11.3333 6V3.33333H3.33325V12.6667H7.33325V6H11.3333ZM4.66659 7.33333H5.99992V8.66667H4.66659V7.33333ZM4.66659 10H5.99992V11.3333H4.66659V10ZM4.66659 4.66667H5.99992V6H4.66659V4.66667Z",
    fill: "#002244"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6644_125816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgBuilding);
export default __webpack_public_path__ + "static/media/svg_building.4acd6a1d8d81820358f07e2d87bbcffb.svg";
export { ForwardRef as ReactComponent };